import React from 'react';

interface Props {
  iso: string | null | undefined;
  absolute?: boolean;
}

const SEC = 1000;
const MIN = 60 * SEC;
const HR = 60 * MIN;
const DAY = 24 * HR;
const WEEK = 7 * DAY;

function relative(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = now - then;

  if (Number.isNaN(then)) return '—';
  if (diff < MIN) return 'just now';
  if (diff < HR) {
    const m = Math.floor(diff / MIN);
    return `${m}m ago`;
  }
  if (diff < DAY) {
    const h = Math.floor(diff / HR);
    return `${h}h ago`;
  }
  if (diff < WEEK) {
    const d = Math.floor(diff / DAY);
    return `${d}d ago`;
  }
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: d.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined,
  });
}

function absoluteFmt(iso: string): string {
  const d = new Date(iso);
  return (
    d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) +
    ' · ' +
    d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  );
}

export const RelativeTime: React.FC<Props> = ({ iso, absolute }) => {
  if (!iso) return <span>—</span>;
  const text = absolute ? absoluteFmt(iso) : relative(iso);
  const title = absolute ? undefined : absoluteFmt(iso);
  return (
    <span title={title} style={{ cursor: title ? 'help' : 'default' }}>
      {text}
    </span>
  );
};
